module.exports = __webpack_public_path__ + "d4cee770d41d22b56647c5bb2d484ca9.png";